module.exports = {"Phase 1A":{},"Phase 1B":{},"Phase 2":{"Basement":[],"Block":["Ground","1","2","3","Roof"]},"Phase 3":{"Basement":[],"Block":["Ground","1","2","3","4","5","6","7","Roof"]},"Site Wide":{"Other (specify below)":[]},"Completed Area (Estates)":{"Other (specify below)":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/highcroft.json
// module id = 120
// module chunks = 0